import { useEffect } from 'react';
import { onLCP, onINP, onCLS, onFCP, onTTFB, Metric } from 'web-vitals';

export interface WebVitalMetric {
  name: string;
  value: number;
  rating: 'good' | 'needs-improvement' | 'poor';
  id: string;
}

export function useWebVitals(onReport?: (metric: WebVitalMetric) => void) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleMetric = (metric: Metric) => {
      const metricObj: WebVitalMetric = {
        name: metric.name,
        value: Math.round(metric.value * 100) / 100,
        rating: metric.rating || 'good',
        id: metric.id
      };

      if (onReport) {
        onReport(metricObj);
      } else {
        const badgeColor = metricObj.rating === 'good' ? '🟢' : metricObj.rating === 'needs-improvement' ? '🟠' : '🔴';
        console.log(`${badgeColor} [Core Web Vitals] ${metricObj.name}: ${metricObj.value}${metricObj.name === 'CLS' ? '' : 'ms'} (${metricObj.rating})`);
      }
    };

    try {
      onLCP(handleMetric);
      onINP(handleMetric);
      onCLS(handleMetric);
      onFCP(handleMetric);
      onTTFB(handleMetric);
    } catch (err) {
      console.warn('Web Vitals collection notice:', err);
    }
  }, [onReport]);
}
